import { render } from "./PatientDiagnosis.vue?vue&type=template&id=67d3efed"
import script from "./PatientDiagnosis.vue?vue&type=script&lang=js"
export * from "./PatientDiagnosis.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__